import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "city-form" }
const _hoisted_2 = { class: "title-form py-5 mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field mb-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "islandId" }, "Pulau", -1)
const _hoisted_7 = { class: "p-field mb-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "province" }, "Provinsi", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-error" }
const _hoisted_11 = {
  key: 1,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field mb-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "codeCity" }, "Kode Kota", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-error" }
const _hoisted_16 = {
  key: 1,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field mb-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "nameCity" }, "Nama Kota", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "p-error" }
const _hoisted_21 = {
  key: 1,
  class: "p-error"
}
const _hoisted_22 = { class: "p-field mb-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "groupCity" }, "Group Kota", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "p-error" }
const _hoisted_26 = {
  key: 1,
  class: "p-error"
}
const _hoisted_27 = {
  key: 0,
  class: "p-field"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "idActive" }, "Aktif", -1)
const _hoisted_29 = {
  class: "btn-action w-full",
  style: {"position":"absolute","bottom":"10px"}
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_31 = {
  class: "p-3 overflow-y-scroll",
  style: {"max-height":"200px","min-width":"28vw"}
}
const _hoisted_32 = {
  key: 0,
  class: "flex w-full justify-center py-2 con-list-group"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus color-primary" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", { class: "color-primary font-semibold" }, "Tambah Grup Baru", -1)
const _hoisted_35 = { class: "text-list-group" }
const _hoisted_36 = { class: "flex items-center justify-between w-full" }
const _hoisted_37 = /*#__PURE__*/_createVNode("h6", null, "Tambah Grup Kota", -1)
const _hoisted_38 = { class: "w-full" }
const _hoisted_39 = { class: "p-field mb-4 w-full" }
const _hoisted_40 = /*#__PURE__*/_createVNode("p", { class: "text-body2" }, "Nama Grup Kota", -1)
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("form", {
      id: "form-city",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Dropdown, {
            id: "islandId",
            modelValue: _ctx.dataForm.islandId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataForm.islandId = $event)),
            options: _ctx.islandOption,
            class: "mt-1",
            optionLabel: "Nama",
            optionValue: "Id",
            placeholder: "Pilih Pulau",
            filter: true,
            filterPlaceholder: "Search Pulau"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_InputText, {
            maxlength: "100",
            id: "province",
            class: "input-primary mt-1",
            name: "province",
            modelValue: _ctx.v$.province.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.province.$model = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.province.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.province.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "new-province-error",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_10, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.province.$invalid && _ctx.submitted) || _ctx.v$.province.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.province.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputText, {
            maxlength: "3",
            id: "codeCity",
            class: "input-primary mt-1 uppercase",
            name: "codeCity",
            modelValue: _ctx.v$.codeCity.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.codeCity.$model = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.codeCity.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_14, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.codeCity.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "new-codeCity-error",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_15, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.codeCity.$invalid && _ctx.submitted) || _ctx.v$.codeCity.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.codeCity.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_InputText, {
            maxlength: "100",
            id: "nameCity",
            class: "input-primary mt-1",
            type: "text",
            name: "cityName",
            modelValue: _ctx.v$.cityName.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.cityName.$model = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.v$.cityName.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_19, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.cityName.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "new-cityName-error",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_20, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.cityName.$invalid && _ctx.submitted) || _ctx.v$.cityName.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.cityName.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_InputText, {
            maxlength: "100",
            id: "groupCity",
            class: "input-primary mt-1",
            type: "text",
            name: "cityGroup",
            autocomplete: "off",
            modelValue: _ctx.nameCityGroup,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.nameCityGroup = $event)),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.groupInput($event)))
          }, null, 8, ["modelValue"]),
          (_ctx.v$.groupCity.$error && _ctx.submitted)
            ? (_openBlock(), _createBlock("span", _hoisted_24, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.groupCity.$errors, (error, index) => {
                  return (_openBlock(), _createBlock("span", {
                    id: "new-groupCity-error",
                    key: index
                  }, [
                    _createVNode("small", _hoisted_25, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]))
            : ((_ctx.v$.groupCity.$invalid && _ctx.submitted) || _ctx.v$.groupCity.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_26, _toDisplayString(_ctx.v$.groupCity.required.$message), 1))
              : _createCommentVNode("", true)
        ]),
        (_ctx.data)
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("div", null, [
                _createVNode(_component_InputSwitch, {
                  id: "idActive",
                  class: "switch-og mt-1",
                  modelValue: _ctx.dataForm.isActive,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataForm.isActive = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    _createVNode("div", _hoisted_29, [
      _createVNode(_component_Button, {
        label: "Simpan",
        type: "submit",
        form: "form-city",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2"
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_30
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      class: "group-city"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_31, [
          (_ctx.checkPermission(_ctx.PermissionEnum.CreateCityGroup))
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _createVNode("div", {
                  class: "flex items-center cursor-pointer gap-2",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openModalGroupCity()))
                }, [
                  _hoisted_33,
                  _hoisted_34
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cityGroupOption, (data, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "flex py-2 cursor-pointer con-list-group",
              key: index,
              onClick: ($event: any) => (_ctx.setObjMsGroupUser(data.Nama, data.Id))
            }, [
              _createVNode("p", _hoisted_35, _toDisplayString(data.Nama), 1)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Dialog, {
      visible: _ctx.modalCityGroup,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_ctx.modalCityGroup = $event)),
      style: {width: '30vw'},
      modal: true,
      closeOnEscape: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode("i", {
            class: "pi pi-times font-bold cursor-pointer",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeDialogGroupCity()))
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_41, [
          _createVNode(_component_Button, {
            label: "Simpan",
            class: "font-semibold p-button-sm btn-primary px-10 mr-2",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitGroupCity()))
          }),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black p-button-sm px-10 py-1",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeDialogGroupCity()))
          }, {
            default: _withCtx(() => [
              _hoisted_42
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, [
            _hoisted_40,
            _createVNode(_component_InputText, {
              maxlength: "100",
              id: "nameGroupCity",
              class: "input-primary mt-1 w-full",
              name: "nameGroupCity",
              modelValue: _ctx.cityGroup,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.cityGroup = $event)),
              type: "text"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}